export default {
  'Submit': 'Kirim',
  'Save': 'Simpan',
  'enterOTP': 'Masukan kode verifikasi',
  'otpSent': 'OTP terkirim',
  'login/signup': 'Masuk daftar',
  'resendCode': 'Kirim ulang Kode',
  'edit': 'edit',
  'otpMessage': 'Kode 6 digit telah dikirim ke nomor ponsel Anda',
  'oyo360WelcomeMessage': 'Masuk daftar',
  'oyo360ResendCode': 'Kirim ulang Kode',
  'oyo360Edit': 'edit',
  'oyo360otpMessage': 'Kode 6 digit telah dikirim ke nomor ponsel Anda',
  'buttonActionContinue': 'Lanjutkan',
  'chooseLanguage': 'Pilih bahasa',
  'currentLanguage': 'Bahasa Saat ini',
  'otherLanguages': 'Bahasa Lainnya',
  'google': 'Google',
  'facebook': 'Facebook',
  'or': 'atau',
  'buttonActionSubmit': 'Kirim',
  'welcomeTitle': 'Selamat datang d OYO',
  'welcomeHeadingForMailLogin': 'Masukkan alamat email terdaftar yang terkait dengan kami',
  'welcomeHeadingForPhoneLogin': 'Masukkan nomor ponsel terdaftar yang terkait dengan kami',
  'welcomeHeadingForLogin': 'Masukkan alamat Email / nomor telepon yang terdaftar',
  'userNameLabel': 'ID Email/Nomor Telepon',
  'userNameErrorMessage':'Silakan masukkan ID Email/Nomor Telepon yang benar',
  'emailIdLabel': 'Alamat Email',
  'phoneNumberLabel': 'Nomor Telepon',
  'passwordLabel': 'Pasword',
  'newPasswordLabel': 'Pasword baru',
  'confirmNewPasswordLabel': 'konfirmasi pasword',
  'emailErrorMessage': 'Silakan masukkan alamat email yang benar',
  'phoneNumberErrorMessage': 'Silakan masukkan nomor telepon yang benar',
  'passwordErrorMessage': 'Silakan masukkan kata sandi yang benar',
  'confirmPasswordErrorMessage': 'Kata sandi tidak cocok!',
  'generateNewPassword': 'Buat kata sandi baru',
  'loginButtonLabel': 'Login',
  'loginWithPhoneButtonLabel': 'Lanjutkan dengan nomor telepon',
  'loginWithOtp': 'Masuk dengan OTP sebagai gantinya',
  'loginWithEmailButtonLabel': 'Lanjutkan dengan alamat Email',
  'back': 'Kembali',
  'loginWithOtpTitle': 'Enter verification code',
  'loginWithOtpHeading': 'Anda akan menerima OTP jika nomor telepon terdaftar di sistem kami',
  'listYourProperty': 'Daftarkan Properti Anda',
  'privacyPolicy': 'kebijakan privasi',
  'verifyEmail': 'verifikasi alamat email',
  'verifyMobile': 'Verifikasi Nomor Ponsel',
  'forgotPasswordPhoneSubHeading': 'Kami akan mengirimkan kode 6 digit untuk memverifikasi nomor telepon Anda',
  'forgotPasswordMailSubHeading': 'Kami akan mengirimkan kode 6 digit untuk memverifikasi ID email Anda',
  'newPasswordCondition1': 'Harus memiliki Nomor & Simbol',
  'newPasswordCondition2': 'Harus memiliki minimal 8 karakter',
  'newPasswordCondition3': 'Harus memiliki huruf kecil & huruf besar',
  'confirmLogin': 'Konfirmasi & Masuk',
  'getOTP': 'Dapatkan OTP',
  'invalidInput': 'yang dimasukan Tidak Valid',
  'passwordResetMessage': 'Kata sandi berhasil dibuat',
  'otpErrorMessage': 'Harap masukkan OTP yang benar',
  'resendOtpSuccessMessage': 'OTP telah berhasil dikirim ulang ke nomor ponsel Anda',
  'InternalServerErrorMessage': 'Kesalahan server dari dalam',
  'resetPasswordHeading': 'Kode 6 digit telah dikirim ke email dan nomor telepon Anda',
  'signingIn': 'masuk',
  'invalidMobileNumber': 'Nomor Ponsel Tidak Valid',
  'privacyFooterText': 'Dengan masuk ke akun Anda, Anda menerima {termsOfUse} dan {privacyPolicy} kami',
  'and': 'dan',
  'termsOfUse': 'persyaratan penggunaan',
  'listProperty': 'Daftarkan Properti Anda',
  'whiteSpace': ' ',

  'errorNoAssociatedHotels': 'Hotel yang Anda cari tidak terdaftar',
  'facingIssue': 'Facing any issue? ',
  'oldLoginViewSwitch': 'Switch to Old view',
  'passwordChangeInformationText': 'Anda akan keluar dari semua perangkat setelah mengubah kata sandi Anda'
};
